import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { promptsKeys } from './prompts.keys';
import { getDefaultPrompts, getPrompts, updatePrompts } from './prompts.api';
export const usePromptsQuery = () => {
    return useQuery({
        queryKey: promptsKeys.all(),
        queryFn: () => getPrompts()
    });
};
export const useDefaultPromptsQuery = () => {
    return useQuery({
        queryKey: promptsKeys.allDefault(),
        queryFn: () => getDefaultPrompts()
    });
};
export const useUpdatePromptsMutation = () => {
    return useMutation({
        mutationFn: updatePrompts,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: promptsKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=prompts.query.js.map